<script lang="ts">
	import type { Locale } from '../../locales/data';

	const { locale }: { locale: Locale } = $props();
</script>

{locale.toLocaleUpperCase(locale)}
{#if locale == 'en'}
	<span class="text-shade-foreground/20 text-sm">Original</span>
{:else}
	<span class="text-shade-foreground/20 text-sm">Auto Translated</span>
{/if}
